import { computed, toValue } from 'vue';
import { useQuery } from '@tanstack/vue-query';

import { queryKeys } from '@/queries/_shared/queryKeys';
import http from '@/services/http';

const PERIODS_PATH = '/periods';

function unwrapBody(data) {
  if (data && typeof data === 'object' && 'body' in data) return data.body;
  return data;
}

function normalizePeriodsResponse(data) {
  const body = unwrapBody(data);
  if (Array.isArray(body)) return body;
  if (Array.isArray(body?.periods)) return body.periods;
  if (Array.isArray(body?.items)) return body.items;
  if (Array.isArray(body?.data)) return body.data;
  return [];
}

function createEmptyPeriodsError() {
  const error = new Error('Периоды пустые. Нужно заполнить периоды в школе.');
  error.config = {
    method: 'get',
    url: PERIODS_PATH
  };
  error.code = 'EMPTY_PERIODS';
  return error;
}

async function fetchPeriods(params = {}) {
  const response = await http.get(PERIODS_PATH, {
    params
  });
  const periods = normalizePeriodsResponse(response.data);
  if (!periods.length) throw createEmptyPeriodsError();
  return periods;
}

export function usePeriodsQuery(params = {}, options = {}) {
  return useQuery({
    queryKey: computed(() => queryKeys.periods.list(toValue(params) || {})),
    queryFn: () => fetchPeriods(toValue(params) || {}),
    ...options,
    retry: false
  });
}

export { fetchPeriods };
